// extracted by mini-css-extract-plugin
export default {"container":"eVA8T_container"};